var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center_quote_cart_box"},[_c('center-title',[_vm._v(_vm._s(_vm.$t("message.cqcart.title")))]),_c('quote-cart-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }